import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class FluxRssService {

  private url = 'https://api.rss2json.com/v1/api.json?rss_url=';

  constructor(private http: HttpClient) { }

  handleErrors(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      console.error('Il y a une erreur : ', error.error.message);
    } else {
      console.error(
        `Erreur de backend : ${error.status}`, error.error
      );
    }
    return throwError('Unexpected Error');
    // return throwError(error.error)
  }

  getAll(url: string): Observable<any> {
    return this.http.get(this.url + url)
      .pipe(
        retry(2),
        catchError(this.handleErrors)
      );
  }
}
